import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { checkUserAuth } from "../redux/slices/authSlice";
import { _admin } from "../constants";
const ProdectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.authToken);
  const { role } = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();
  let location = useLocation();
  if (role !== _admin.Admin) {
    // dispatch(checkUserAuth());
    // Redirect them to the /dashboard page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    // return <Navigate to="/" state={{ from: location }} />;
    return <Navigate to="/reports/systemUsageReports" />;
  }
  return children;
};

export default ProdectedRoute;
